const VALUE_HIDDEN = "!hidden"

export default VALUE_HIDDEN
